import React from "react";
import css from "./Bold.module.css";

const Bold = (props) => {
  return <span className={css.root}>{props.children}</span>;
};

export default Bold;
